import { useState } from "react";
import { ConnectAccountOnboarding, ConnectComponentsProvider } from "@stripe/react-connect-js";
import useStripeConnect from "../useStripeConnect";
import { Box, Skeleton } from "@mui/material";
import { colors } from "../../../theme/palette";

export default function CreatePaymentAccount() {
  const { stripeConnectInstance, isStripeConnectInstanceLoading, handleOnFinishingOnBoardingSteps } =
    useStripeConnect();

  const [isComponentReady, setIsComponentReady] = useState(false);

  return (
    <Box
      sx={{
        padding: "12px",
        background: colors.White,
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        width: "870px",
        minHeight: "226px",
        overflow: "hidden",
      }}
    >
      {(!stripeConnectInstance || !isComponentReady) && isStripeConnectInstanceLoading && (
        <CreatePaymentAccountLoader />
      )}

      {stripeConnectInstance && (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
          <ConnectAccountOnboarding
            onExit={handleOnFinishingOnBoardingSteps}
            onStepChange={(step) => {
              if (!isComponentReady && !!step) setIsComponentReady(true);
            }}
          />
        </ConnectComponentsProvider>
      )}
    </Box>
  );
}

const CreatePaymentAccountLoader = () => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "48px" }}>
    <Skeleton sx={{ width: "320px", height: "24px", marginBottom: "6px" }} />
    <Skeleton sx={{ width: "620px", height: "20px", marginBottom: "28px" }} />
    <Skeleton sx={{ width: "126px", height: "30px" }} />
  </Box>
);
